/**
 * @ipc/admin-ui · widgets/app-shell · mobile-nav —
 * Бургер-кнопка + Sheet слева с полным навбаром (пункты + профиль).
 * Используется на viewport < md и в TWA-оболочке.
 */
import { useState } from 'react';
import { Menu } from 'lucide-react';
import { Button, Sheet, SheetContent, SheetTrigger } from '@/shared/ui';
import { cn } from '@/shared/lib';
import type { SessionUser } from '@/entities/session';
import { NavSidebarContent } from './nav-sidebar';
import { BrandLogo } from './brand-logo';

export function MobileNav({ user }: { user: SessionUser }) {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-9 shrink-0"
          aria-label="Открыть меню"
        >
          <Menu className="size-5" />
        </Button>
      </SheetTrigger>
      <SheetContent
        side="left"
        title="Навигация"
        hideCloseButton={false}
        className={cn(
          'w-[min(100%-1.5rem,280px)] gap-0 overflow-hidden p-0 sm:max-w-[280px]',
          // TWA fullscreen: не залезать под notch / close button / home bar
          'top-[max(0.75rem,var(--ipc-twa-inset-top))]',
          'left-[max(0.75rem,var(--ipc-twa-inset-left))]',
          'bottom-[max(0.75rem,var(--ipc-twa-inset-bottom))]',
        )}
      >
        <NavSidebarContent
          user={user}
          onNavigate={() => setOpen(false)}
          className="h-full min-h-0 rounded-xl"
        />
      </SheetContent>
    </Sheet>
  );
}

/**
 * Верхняя полоса mobile/TWA: бургер + логотип.
 */
export function MobileShellHeader({
  user,
  className,
}: {
  user: SessionUser;
  className?: string;
}) {
  return (
    <header
      className={cn(
        // px совпадает с --ipc-page-px (1rem), чтобы бургер/лого = левый край контента
        'flex shrink-0 items-center gap-2 border-b border-border bg-card px-4 py-2',
        className,
      )}
    >
      <MobileNav user={user} />
      <BrandLogo className="block h-[15px]" />
    </header>
  );
}
